<div class="horizontal-wrap gallery {{textStyle}}" [ngStyle]="{'background-color': backgroundColor}">
    <h2 *ngIf="galleryTitle" class="heading-1">{{galleryTitle}}</h2>

    <div class="gallery-card" *ngFor="let item of galleryItems; trackBy: trackByFn">
        <gallery-sub-item [componentData]="item" [pageUrl]="pageUrl" [parentCardName]="componentData.name" [useLocaleOverride]="useLocaleOverride"></gallery-sub-item>
    </div>
</div>
